export default __webpack_public_path__ + "static/banner-home-improvement-trends-7bfcfdb70595aab5b6d94bf90463d5fe.jpg";